import React, { useState } from 'react';
import { Form, Button } from 'react-bootstrap';
import { setFlashMessage } from '../../contexts/WebsiteContext';

function TicketAnswerForm({ ticketId, apiUrl, token, onAnswerPosted }) {
    const [answer, setAnswer] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handlePostAnswer = async () => {
        setIsSubmitting(true);
        try {
            const response = await fetch(`${apiUrl}ticket/${ticketId}/answer`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    Authorization: `Bearer ${token}`,
                },
                body: new URLSearchParams({ content: answer }).toString(),
            });

            if (!response.ok) throw new Error("Erreur lors de l'envoi de la réponse");

            const data = await response.json();
            setFlashMessage("Réponse envoyée avec succès", "success");
            setAnswer('');
            onAnswerPosted(data);
        } catch {
            setFlashMessage("Une erreur s'est produite", "error");
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div style={{ marginTop: '20px' }}>
            <Form.Group>
                <Form.Label style={{ fontSize: '16px', fontWeight: 'bold' }}>
                    Ajouter une réponse :
                </Form.Label>
                <Form.Control
                    as="textarea"
                    rows={3}
                    value={answer}
                    onChange={(e) => setAnswer(e.target.value)}
                    disabled={isSubmitting}
                    style={{
                        borderRadius: '4px',
                        border: '1px solid #ced4da',
                        padding: '10px',
                    }}
                />
            </Form.Group>
            <Button
                variant="primary"
                onClick={handlePostAnswer}
                disabled={isSubmitting || !answer.trim()}
                style={{
                    marginTop: '10px',
                    backgroundColor: '#007bff',
                    borderColor: '#007bff',
                    padding: '5px 15px',
                    borderRadius: '4px',
                }}
            >
                {isSubmitting ? 'Envoi...' : 'Répondre'}
            </Button>
        </div>
    );
}

export default TicketAnswerForm;